import React from 'react'
import { makeStyles } from '@material-ui/core'
import type { Theme } from '@material-ui/core/styles'
import type { StyleClasses } from '../../styles'
import type { QuoteTag } from 'paintscout'
import { Grid, IconButton, Paper, QuoteTagChip, Typography, useUser } from '../..'
import EditIcon from '@material-ui/icons/Edit'
import classNames from 'classnames'

const useStyles = makeStyles<Theme, TagContainerProps>(
  (theme) => ({
    root: {},
    tagsContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      paddingLeft: theme.spacing(2)
    },
    tagsHeader: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      width: '100%',
      alignItems: 'center',
      paddingBottom: theme.spacing(1),
      height: '3.5rem',
      paddingRight: theme.spacing(0.5)
    },
    tagsBody: {
      paddingBottom: theme.spacing(3)
    },
    noTagsBody: {
      paddingBottom: theme.spacing(3),
      justifyContent: 'center',
      display: 'flex',
      alignItems: 'center',
      marginLeft: `-${theme.spacing(2)}px`
    },
    editButton: {
      '@media print': {
        display: 'none'
      }
    }
  }),
  { name: 'TagContainer' }
)

export interface TagContainerProps {
  classes?: StyleClasses<typeof useStyles>
  tags: QuoteTag[]
  handleEdit: () => void
  handleDelete: (tag: QuoteTag) => void
  disabled?: boolean
}

function TagContainer(props: TagContainerProps) {
  const classes = useStyles(props)
  const { tags, handleEdit, handleDelete, disabled = false } = props
  const { isCrew } = useUser()

  return (
    <Paper className={classNames(classes.tagsContainer, 'tag-container')}>
      <div className={classes.tagsHeader}>
        <Typography variant={'h3'}>Tags</Typography>
        {!isCrew && !disabled && (
          <IconButton onClick={handleEdit} className={classes.editButton}>
            <EditIcon />
          </IconButton>
        )}
      </div>
      {tags.length === 0 && (
        <div className={classes.noTagsBody}>
          <Typography variant={'subtitle1'}>No tags found.</Typography>
        </div>
      )}
      {tags.length > 0 && (
        <div className={classes.tagsBody}>
          <Grid container spacing={1}>
            {tags.map((tag) => {
              return (
                <Grid item key={tag.name}>
                  <QuoteTagChip tag={tag} handleDelete={isCrew || disabled ? null : handleDelete} />
                </Grid>
              )
            })}
          </Grid>
        </div>
      )}
    </Paper>
  )
}

export default TagContainer
